import React from "react";
import { FieldArray } from "redux-form";

import { Button } from "components";
import { MiscFee } from "models";

import MiscFeeBlock from "./miscFeeBlock";

const RenderFields = ({ fields, form, validators, isPaperApplication }) => {
	const handleAdd = () => fields.push(new MiscFee());
	const handleRemove = () => fields.pop();

	return (
		<>
			{fields.map((_, i) => {
				return (
					<MiscFeeBlock
						key={`miscFee${i}`}
						index={i}
						fields={fields}
						form={form}
						validators={validators}
						isPaperApplication={isPaperApplication}
					/>
				);
			})}
			<div className="mb-3">
				<Button
					onClick={handleAdd}
					value="Add misc fee"
					variant="secondary"
					className="px-0"
					minWidth="auto"
					disabled={fields.length >= 2}
				/>
				{fields.length > 1 && (
					<Button
						onClick={handleRemove}
						value="Remove misc fee"
						variant="secondary"
						className="ml-4 px-0"
						minWidth="auto"
					/>
				)}
			</div>
		</>
	);
};

const MiscFees = ({ form, validators, isPaperApplication = false }) => {
	return (
		<FieldArray
			name="miscFees"
			props={{
				form,
				validators,
				isPaperApplication,
			}}
			component={RenderFields}
		/>
	);
};

export default MiscFees;
